import React from 'react';
import type { LucideIcon } from 'lucide-react';

export type T05ReferoAccent = 'coral' | 'voltage' | 'gold' | 'trust';

export interface T05ReferoFeatureBullet {
  icon?: LucideIcon;
  text: string;
}

export interface T05ReferoFeatureRowProps {
  id?: string;
  reverse?: boolean;
  accent?: T05ReferoAccent;
  label: string;
  labelIcon?: LucideIcon;
  title: React.ReactNode;
  description: string;
  bullets?: T05ReferoFeatureBullet[];
  footer?: React.ReactNode;
  visual: React.ReactNode;
  className?: string;
}

export const T05ReferoFeatureRow: React.FC<T05ReferoFeatureRowProps> = ({
  id,
  reverse = false,
  accent = 'voltage',
  label,
  labelIcon: LabelIcon,
  title,
  description,
  bullets,
  footer,
  visual,
  className = '',
}) => {
  const rowClass = [
    't05-refero-feature',
    'reveal-up',
    reverse ? 't05-refero-feature--reverse' : '',
    `t05-refero-feature--${accent}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <article className={rowClass} id={id}>
      <div className="t05-refero-feature__copy">
        <p className="t05-refero-feature__label">
          {LabelIcon ? <LabelIcon size={15} strokeWidth={2.25} aria-hidden /> : null}
          <span>{label}</span>
        </p>
        <h2 className="t05-refero-feature__title">{title}</h2>
        <p className="t05-refero-feature__lead">{description}</p>
        {bullets && bullets.length > 0 ? (
          <ul className="t05-refero-feature__bullets">
            {bullets.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.text}>
                  {Icon ? <Icon size={15} strokeWidth={2} aria-hidden /> : null}
                  <span>{item.text}</span>
                </li>
              );
            })}
          </ul>
        ) : null}
        {footer ? <div className="t05-refero-feature__footer">{footer}</div> : null}
      </div>

      <div className="t05-refero-feature__visual" aria-hidden={false}>
        <div className="t05-refero-feature__visual-glow" aria-hidden />
        <div className="t05-refero-feature__visual-inner">{visual}</div>
      </div>
    </article>
  );
};
